module.exports = __webpack_public_path__ + "static/img/bg-tr.6729ea70.png";